import { checkGate, getExperiment, getLayer } from '@eventbrite/statsig';
import {
    ConfirmationPageReferralExperimentVariant,
    EnhanceLogionOptionExperimentVariant,
    ENHANCE_LOGIN_OPTION_IN_CHECKOUT_EXPERIMENT,
    ExpressOnlyCheckoutExperimentVariant,
    ExpressPaymentMethods,
    EXPRESS_CHECKOUT_ONLY_CHECKOUT_EXPERIMENT,
    FOLLOW_CARD_PLACEMENT_EXPERIMENT,
    GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT,
    ONLINE_EVENT_ATTENDEE_LOCATION_FIELDS,
    ORDER_CONFIRMATION_PAGE_REFERRAL_EXPERIMENT,
} from '../../constants/statsig';

export { getPostCheckoutMandatoryQuestionsInApp } from './getPostCheckoutMandatoryQuestionsInApp';

export const checkEnablePayPalLineItemsFeatureGate = () =>
    checkGate('checkout_enable_paypal_line_items');

export const getFollowCardPlacementExperiment = () =>
    getLayer(
        FOLLOW_CARD_PLACEMENT_EXPERIMENT.layer,
        FOLLOW_CARD_PLACEMENT_EXPERIMENT.param,
        FOLLOW_CARD_PLACEMENT_EXPERIMENT.defaultValue,
    );

export const getGooglePayOnTicketSelectionExperimentValue =
    (): ExpressPaymentMethods =>
        getLayer(
            GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT.layer,
            GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT.param,
            GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT.defaultValue,
        );

export const getReferralInOrderConfirmationExperiment =
    (): ConfirmationPageReferralExperimentVariant =>
        getExperiment(
            ORDER_CONFIRMATION_PAGE_REFERRAL_EXPERIMENT.experiment,
            ORDER_CONFIRMATION_PAGE_REFERRAL_EXPERIMENT.param,
            ORDER_CONFIRMATION_PAGE_REFERRAL_EXPERIMENT.defaultValue,
        );

export const getExpressOnlyCheckoutExperiment =
    (): ExpressOnlyCheckoutExperimentVariant =>
        getLayer(
            EXPRESS_CHECKOUT_ONLY_CHECKOUT_EXPERIMENT.layer,
            EXPRESS_CHECKOUT_ONLY_CHECKOUT_EXPERIMENT.param,
            EXPRESS_CHECKOUT_ONLY_CHECKOUT_EXPERIMENT.defaultValue,
        );

export const getEnhanceLoginOptionExperimentValue =
    () => (): EnhanceLogionOptionExperimentVariant =>
        getExperiment(
            ENHANCE_LOGIN_OPTION_IN_CHECKOUT_EXPERIMENT.experiment,
            ENHANCE_LOGIN_OPTION_IN_CHECKOUT_EXPERIMENT.param,
            ENHANCE_LOGIN_OPTION_IN_CHECKOUT_EXPERIMENT.defaultValue,
        );

export const getOnlineEventAttendeeLocationFieldsExperimentValue =
    (): boolean =>
        getLayer(
            ONLINE_EVENT_ATTENDEE_LOCATION_FIELDS.layer,
            ONLINE_EVENT_ATTENDEE_LOCATION_FIELDS.param,
            ONLINE_EVENT_ATTENDEE_LOCATION_FIELDS.defaultValue,
        );
